import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed:300, 400, 700|Roboto:300,400,700");
body{
        background: #171717;
        font-family:'Roboto', sans-serif;
        margin:0;
        padding:0;
        color: #e3e3e3 !important;
        overflow:hidden;
    }
ul{
        margin:0;
        padding:0;
}

@media (max-width: 1024px) {
    body{
        overflow-x:hidden;
        overflow-y:hidden;
    }
}
`
export default GlobalStyle